import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';
import { NgxMaskDirective } from 'ngx-mask';
import { CompanyDescriptionComponent } from './company-description/company-description.component';
import { CompanyInfoComponent } from './company-info/company-info.component';
import { CompanySearchComponent } from './company-search/company-search.component';
import { InternationalActivityComponent } from './international-activity/international-activity.component';
import { RegisteredAddressComponent } from './registered-address/registered-address.component';
import { SalesChannelComponent } from './sales-channel/sales-channel.component';
import { TradingAddressComponent } from './trading-address/trading-address.component';


@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        TranslateModule,
        ReactiveFormsModule,
        NgSelectModule,
        NgxMaskDirective
    ],
    declarations: [
        CompanyDescriptionComponent,
        CompanyInfoComponent,
        CompanySearchComponent,
        RegisteredAddressComponent,
        InternationalActivityComponent,
        SalesChannelComponent,
        TradingAddressComponent
    ]
})
export class CompanyStepModule { }
